import React from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import "./Disclaimer.css";

const Disclaimer = () => {
  return (
    <Box className="disclaimer-container">
      <Container maxWidth="md" className="disclaimer-box">
        <Typography variant="h4" className="disclaimer-title">Disclaimer</Typography>
        <Typography variant="body1" className="disclaimer-text">
          Welcome to AllYonoMaster. This extensive disclaimer applies to all users of the AllYonoMaster website and the wide array of applications ("Apps") available on it. Our platform includes diverse apps such as Poker, Rummy, Ludo, fantasy sports, investment apps, and trading apps. By accessing AllYonoMaster, you acknowledge and agree to the terms outlined in this disclaimer.
        </Typography>

        <Typography variant="h5" className="disclaimer-subtitle">Understanding the Scope of Our Platform</Typography>
        <Typography variant="body1" className="disclaimer-text">
          AllYonoMaster serves as a digital distribution platform for various third-party applications. Our role is limited to providing access to these apps. We do not develop, modify, or have any control over the content and functionality of these apps.
        </Typography>

        <Typography variant="h5" className="disclaimer-subtitle">User Responsibility and Financial Risk</Typography>
        <Typography variant="body1" className="disclaimer-text">
          <strong>Risk of Financial Activities:</strong> The Apps, particularly those involving financial transactions like betting games or investment platforms, may carry inherent risks including the potential for significant financial loss. You are solely responsible for any financial outcomes resulting from your use of these Apps.
        </Typography>

        <Typography variant="h5" className="disclaimer-subtitle">No Liability for Losses</Typography>
        <Typography variant="body1" className="disclaimer-text">
          AllYonoMaster shall not be liable for any direct, indirect, incidental, consequential, or punitive damages, including financial losses, resulting from the use or inability to use any App listed on our website.
        </Typography>

        <Box className="important-notice">
          <Typography variant="h5" className="notice-title">Important Notice</Typography>
          <Typography variant="body1" className="notice-text">
            AllYonoMaster does not operate or own the apps listed on this platform. The rummy app can be addictive and financially risky, so use it responsibly. Only for users aged 18+.
          </Typography>
          <Typography variant="body1" className="notice-text">
            Alert: Rummy, a skill-based game, is banned in the states of Andhra Pradesh, Sikkim, Nagaland, Assam, Arunachal Pradesh, Tamil Nadu, Odisha, and Telangana.
          </Typography>
        </Box>

        {/* Join Links */}
        <Box className="join-links">
          <Button
            variant="contained"
            color="primary"
            className="join-button telegram"
            href="https://t.me/AllYonoMaster"
            target="_blank"
          >
            Join Our Telegram Channel
          </Button>

          <Button
            variant="contained"
            color="success"
            className="join-button whatsapp"
            href="https://wa.me/"
            target="_blank"
          >
            Join Us On WhatsApp
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Disclaimer;
